import { MapWithDefault } from '@app-shared/functions/helpers.functions';

export enum SortByFilter {
  SHORTAGE_DATE = 'shortage_date',
  MOST_REPORTED = 'most_reported',
  BIGGEST_VOLUME = 'biggest_volume',
  SHORTAGE_STATUS = 'shortage_status',
  NAME = 'description',
  DESCRIPTION = 'product_description',
  BACK_IN_STOCK_DATE = 'back_in_stock_date',
  PRICE = 'public_price',
  SANDOZ_ALTERNATIVE_AVAILABLE = 'number_of_sandoz_alternatives',
  IS_SANDOZ = 'is_sandoz',
  NEW_LISTINGS = 'new_listings',
  STOCKOUT_DATE = 'shortage.shortage_date',
  EXPECTED_AVAILABILITY = 'shortage.expected_availability',
  MANUFACTURER = 'manufacturer.name',
  NUMBER_OF_ALTERNATIVES = 'number_of_alternatives',
  SHORTAGE_DURATION = 'shortage.shortage_duration',
  PRODUCT_ID = 'product_identifier',
  ORDER_CREATION_DATE = 'last_order_created_on',
  CUSTOMER_GROUP = 'customer_group',
  VIP_EXPECTED_STOCKOUT_DATE = 'shortage.vip_expected_stockout_date',
  EXPECTED_STOCKOUT_LENGTH = 'shortage.expected_stockout_length',
  REMAINING_STOCK = 'shortage.remaining_stock',
  VIP_EXPECTED_AVAILABILITY_DATE = 'shortage.vip_expected_availability_date',
  QUANTITY_AVAILABLE_WHS = 'quantity_available_though_whs',
  NUMBER_OF_CUSTOMERS = 'number_of_customers',
  COUNTRY_NAME = 'country.name',
  SKU_CODE = 'material_number',
  NATIONAL_CODE = 'national_identifier',
}

/**
 * Map of names for the sorting filters
 */
export const sortByFilterNameMap = new MapWithDefault<SortByFilter, string>(
  '',
  [
    [SortByFilter.SHORTAGE_DATE, 'PRODUCT.FILTER.SORT.SHORTAGE_DATE'],
    [SortByFilter.MOST_REPORTED, 'PRODUCT.FILTER.SORT.MOST_REPORTED'],
    [SortByFilter.BIGGEST_VOLUME, 'PRODUCT.FILTER.SORT.BIGGEST_VOLUME'],
    [SortByFilter.SHORTAGE_STATUS, 'GENERAL.STATUS'],
    [SortByFilter.NAME, 'PRODUCT.FILTER.SORT.NAME'],
    [SortByFilter.DESCRIPTION, 'PRODUCT.FILTER.SORT.DESCRIPTION'],
    [
      SortByFilter.BACK_IN_STOCK_DATE,
      'PRODUCT.TABLE.COLUMN_LABEL.BACK_IN_STOCK_DATE',
    ],
    [SortByFilter.PRICE, 'PRODUCT.FILTER.SORT.PRICE'],
    [
      SortByFilter.SANDOZ_ALTERNATIVE_AVAILABLE,
      'PRODUCT.FILTER.SORT.SANDOZ_ALTERNATIVE_AVAILABLE',
    ],
    [SortByFilter.IS_SANDOZ, 'PRODUCT.FILTER.SORT.SANDOZ_FIRST'],
    [SortByFilter.NEW_LISTINGS, 'PRODUCT.FILTER.SORT.NEW_LISTINGS'],
  ],
);

export enum SortByOrder {
  ASC = 'asc',
  DESC = 'desc',
}
